module.exports = __webpack_public_path__ + "static/media/itinker_logo.6e750f68.png";